import { ChangeEvent, FC, useState } from 'react';

import SunshineModal from 'components/_core/SunshineModal';
import ClientContactForm from 'features/Work/components/ClientContactForm';
import { createEmptyClientContact } from 'features/Work/pages/Clients/components/FormModal/hooks/useClientFormModalContext';
import { useCreateClientContact } from 'features/Work/pages/Clients/hooks/useCreateClientContact';
import { CreateClientContactMutation } from 'features/Work/pages/Clients/hooks/useCreateClientContact/graphql/createClientContact.gql';
import { ClientQuery } from 'features/Work/pages/Clients/hooks/useGetClient/graphql/client.gql';

import locales from './locales';

interface AddClientContactModalProps {
  client: ClientQuery['client'];
  hideModal: () => void;
  isOpen: boolean;
  selectNewContact: (
    contact: CreateClientContactMutation['createClientContact']['clientContact'],
  ) => void;
}

const AddClientContactModal: FC<AddClientContactModalProps> = ({
  client,
  hideModal,
  isOpen,
  selectNewContact,
}) => {
  const [clientContact, setClientContact] = useState(
    createEmptyClientContact(),
  );

  const { clientId, name } = client;

  const { createClientContact, loading } = useCreateClientContact(clientId);

  const onChange = (e: ChangeEvent<HTMLInputElement>) =>
    setClientContact({
      ...clientContact,
      [e.target?.name]: e.target?.value,
    });

  const onSubmit = async () => {
    const { data } = await createClientContact(clientContact);
    const newClientContact = data?.createClientContact?.clientContact;
    if (newClientContact) {
      selectNewContact(newClientContact);
    }
    hideModal();
  };

  return (
    <SunshineModal isOpen={isOpen} onClose={hideModal}>
      <ClientContactForm
        clientContact={clientContact}
        loading={loading}
        modalTitle={locales.formatString(locales.modalTitle, name) as string}
        onChange={onChange}
        onSubmit={onSubmit}
        submitButtonText={locales.addContact}
      />
    </SunshineModal>
  );
};

export default AddClientContactModal;
